<script setup lang="ts">
import { useTheme } from 'vuetify';
import OILightLogoFull from '../assets/oi-logo-White-rgb.svg'
import OIDarkLogoFull from '../assets/oi-logo-full-color-rgb.svg'

import { LOGO_LIGHT, LOGO_DARK } from '../vueify';

const theme = useTheme()

</script>
<template>
    <div>
        <img v-if="theme.global.current.value.dark" :src="LOGO_LIGHT ? LOGO_LIGHT : OILightLogoFull" class="w-100" />
        <img v-else :src="LOGO_DARK ? LOGO_DARK : OIDarkLogoFull" class="w-100" />
    </div>
    <!-- <v-img v-if="theme.global.current.value.dark" :src="OILightLogoFull"></v-img>
        <v-img v-else :src="OIDarkLogoFull"></v-img> -->
</template>